import React, { Component } from "react";
import logo from "./logo.svg";
import Stories from "react-insta-stories";
import withLoader from "react-insta-stories";
import useStories from "react-insta-stories";
// import { storyList } from "mock/stories";
import "../App/App.css";
import ReactInstaStoriesProps from "react-insta-stories";
import { useState } from "react";
import { EmojiDefault, MuteSVG, UnMuteSVG } from "components/SVG/svg";
import loveEmoji from "assets/love_emoji.png";
import nahEmoji from "assets/nah_emoji.png";
import mehEmoji from "assets/meh_emoji.png";
import defaultEmoji from "assets/defaultEmoji.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEffect } from "react";
import {
  getStories,
  getStorySegmentItemReact,
  updateStoryReaction,
} from "store/async-actions/hive";
import {
  getStartClickedSelector,
  getStoriesListSelector,
  getStorySegmentItemReactSelector,
  setCurrentStoryItem,
  setStoryUuid,
} from "store/reducers/hive";
import { OrganizationStoryObject } from "api/models/community";
import clientApi from "api";

function Story() {
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const [currentStory, setCurrentStory] = useState({
    selectedEmoji: "default",
    storyItemId: 0,
    storyUuid: "",
    url: "",
    title: "",
    description: "",
    type: "",
    actionLink: "",
    colorCode: "",
    longDescriptionList: [],
    textColorCode: "",
  });

  const emojis = [
    {
      reactionEmoji: loveEmoji,
      reactionType: "love",
      reactionId: 3,
    },
    {
      reactionEmoji: mehEmoji,
      reactionType: "meh",
      reactionId: 2,
    },
    {
      reactionEmoji: nahEmoji,
      reactionType: "nah",
      reactionId: 1,
    },
  ];

  const location = useLocation();
  const [showSelections, setShowSelections] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const urlParams = location.search.split("?")[1];
  const [firstStoryLoaded, setFirstStoryLoaded] = useState(false);

  const handleStoryStart = (s: any, st: any) => {
    if (s === 0 && !firstStoryLoaded) {
      setIsPaused(false);
    }
    setCurrentStoryIndex(st);
    setCurrentStory(st);

    dispatch(
      getStorySegmentItemReact({
        storyUuid: storyUuid,
        storySegmentId: st.storyItemId,
        sessionId: clientApi.sessionId,
      })
    );

    dispatch(setCurrentStoryItem(st));
  };

  const segmentItemReactions = useAppSelector(getStorySegmentItemReactSelector);

  const getSelectedEmojiSrc = () => {
    const emoji =
      segmentItemReactions &&
      emojis.find(
        (emojiObj) => emojiObj.reactionId === +segmentItemReactions?.reactionId
      );
    return emoji ? emoji.reactionEmoji : defaultEmoji;
  };

  const storyListReduced = useAppSelector(getStoriesListSelector);
  const dispatch = useAppDispatch();
  const [selectedEmoji, setSelectedEmoji] = useState(
    currentStory?.selectedEmoji
  );

  const url = location.pathname;
  const secondSlashIndex = url.indexOf("/", url.indexOf("/") + 1);
  const thirdSlashIndex = url.indexOf("/", secondSlashIndex + 1);
  const storyUuid = url.substring(
    secondSlashIndex + 1,
    thirdSlashIndex !== -1 ? thirdSlashIndex : url.length
  );

  // const url = location.pathname;
  // const secondSlashIndex = url.indexOf("/", url.indexOf("/") + 1);
  // const thirdSlashIndex = url.indexOf("/", secondSlashIndex + 1);
  // // const fourthSlashIndex = url.indexOf("/", thirdSlashIndex + 1);
  // const storyUuid = url.substring(
  //   secondSlashIndex + 1,
  //   thirdSlashIndex !== -1 ? thirdSlashIndex : url.length
  // );

  const startClicked = useAppSelector(getStartClickedSelector);

  const navigate = useNavigate();

  useEffect(() => {
    !startClicked &&
      storyUuid &&
      navigate(`/home?${localStorage.getItem("storyUuid")}`);
  }, [dispatch]);

  useEffect(() => {
    if (storyUuid) {
      dispatch(setStoryUuid(storyUuid));
      window.dispatchEvent(
        new CustomEvent("analyticsEvent", {
          detail: {
            ctaName: "storyInit",
            pageName: location.pathname.slice(1),
            storyUuid: storyUuid,
            // organizationUuid: hiveDetails.communityUuid,
          },
        })
      );
    }
  }, [storyUuid]);

  const setEmoji = (e: any) => {
    setCurrentStory((prevState) => ({
      ...prevState,
      selectedEmoji: e.reactionType,
    }));
    dispatch(
      updateStoryReaction({
        storyUuid: currentStory.storyUuid,
        storySegmentId: currentStory.storyItemId,
        reactionId: e.reactionId,
        reactionType: e.reactionType,
        sessionId: clientApi.sessionId,
      })
    );
    setSelectedEmoji(e.reactionType);
    setShowSelections(false);
  };

  const [isMuted, setIsMuted] = useState(false);

  const toggleMute = () => {
    const videos = document.querySelectorAll("video");

    videos.forEach((video) => {
      video.muted = !isMuted;
    });

    setIsMuted(!isMuted);
  };

  useEffect(() => {
    if (urlParams) {
      dispatch(setStoryUuid(urlParams));
      dispatch(getStories({ storyUuid: urlParams }));
    }
  }, [dispatch, urlParams]);

  const handlePause = () => {
    setIsPaused(!isPaused);
  };

  const handleActionClick = (url: string) => {
    window.dispatchEvent(
      new CustomEvent("analyticsEvent", {
        detail: {
          ctaName: "actionLinkClick",
          pageName: location.pathname.slice(1),
          storyUuid: storyUuid,
          request: currentStory.storyItemId,

          // organizationUuid: hiveDetails.communityUuid,
        },
      })
    );
    window.open(url, "_blank");
  };

  return (
    <div className="stories_container_wrapper">
      <div className="stories_container">
        <div className="full_wrap">
          <div
            style={{
              backgroundColor: currentStory.colorCode,
            }}
            className="stories_wrapper"
          >
            {storyListReduced && storyListReduced.length > 0 && (
              <Stories
                storyStyles={{
                  backgroundColor: currentStory.colorCode,
                  objectFit: "cover",
                  width: "720px",
                }}
                loop
                keyboardNavigation
                defaultInterval={8000}
                stories={storyListReduced}
                width="100%"
                height="100%"
                isPaused={isPaused}
                onAllStoriesEnd={(s: any, st: any) =>
                  console.log("all stories ended", s, st)
                }
                onStoryStart={handleStoryStart}
              />
            )}
            <div onClick={handlePause} className="pause_element"></div>
            {/* {!!currentStory.longDescriptionList &&
              currentStory.longDescriptionList[0] && (
                <div className="story_long_desc_wrapper">
                  {currentStory.longDescriptionList.map((data, idx) => {
                    return (
                      <ul
                        style={{ color: "#fff" }}
                        // style={{ color: currentStory.textColorCode }}
                        className="long_desc_data"
                      >
                        <p>•</p>
                        <p>{data}</p>
                      </ul>
                    );
                  })}
                </div>
              )} */}
            {currentStory.type === "video" && (
              <div onClick={toggleMute} className="mute_button">
                {isMuted ? <MuteSVG /> : <UnMuteSVG />}
              </div>
            )}
            <div className="full_z story_bottom_ak">
              <div className="title_and_emoji_styling">
                <div className="story_title_wrapper_ak">
                  <h2 className="stories_title">{currentStory.title}</h2>
                  <p className="stories_desc">{currentStory.description}</p>
                </div>
                <div className="full_z emoji_container_items">
                  <div
                    className="full_z"
                    onClick={() => setShowSelections((prevState) => !prevState)}
                  >
                    <img
                      src={getSelectedEmojiSrc()}
                      className={
                        currentStory.selectedEmoji ? "emoji" : "default_emoji"
                      }
                      alt="selected emoji"
                    />
                  </div>
                  <div>
                    {showSelections && (
                      <div className="emojis_wrapper">
                        {emojis.map((emojiObj) => (
                          <img
                            key={emojiObj.reactionId}
                            onClick={() => setEmoji(emojiObj)}
                            src={emojiObj.reactionEmoji}
                            className="emoji"
                            alt={emojiObj.reactionType}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {currentStory?.actionLink && currentStory.actionLink !== "" && (
                <div
                  onClick={() => handleActionClick(currentStory.actionLink)}
                  className="secondaryBtn show_more_btn full_zz"
                >
                  Click here
                </div>
              )}
            </div>
            {/* <div className="full_z stories_bottom_container">
              <div className="stories_desc_section">
                <div className="stories_title">{currentStory?.title}</div>
                <div className="stories_desc">{currentStory?.description}</div>
              </div>
              <div className="full_z emoji_container_items">
                <div>
                  {showSelections && (
                    <div className="emojis_wrapper">
                      {emojis.map((emojiObj) => (
                        <img
                          key={emojiObj.reactionId}
                          onClick={() => setEmoji(emojiObj)}
                          src={emojiObj.reactionEmoji}
                          className="emoji"
                          alt={emojiObj.reactionType}
                        />
                      ))}
                    </div>
                  )}
                </div>
                <div
                  className="full_z"
                  onClick={() => setShowSelections((prevState) => !prevState)}
                >
                  <img
                    src={getSelectedEmojiSrc()}
                    className={
                      currentStory.selectedEmoji ? "emoji" : "default_emoji"
                    }
                    alt="selected emoji"
                  />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Story;
